import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA (with auto-update on new deploys)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Check for updates every time the page loads (catches new deploys)
        reg.update().catch(() => {});

        // When a new SW has installed and is waiting, tell it to take over
        // immediately so the user gets the fresh build without manual refresh.
        const promptUpdate = (worker) => {
          if (!worker) return;
          if (worker.state === 'installed' && navigator.serviceWorker.controller) {
            worker.postMessage({ type: 'SKIP_WAITING' });
          }
        };
        if (reg.waiting) promptUpdate(reg.waiting);
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => promptUpdate(newWorker));
        });
      })
      .catch((err) => console.log("SW registration failed:", err));

    // When the active SW changes, reload once so the page loads under the
    // fresh bundle.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
